import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager, Variables } from 'core/index';

import { ProjectConnManager } from 'apps/project/connManager';

import { InitiativeCommunityProfileProjectsQuery } from 'apps/project/gql';

export class InitiativeProjectsManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.variables = new Variables({
      count: () => this.projectsConn.variables.batchSize,
      cursor: () => null,
      sortBy: () => this.projectsConn.sortBy,
    });
    this.projectsConn = new ProjectConnManager(this, {
      sortBy: 'recent',
      initialBatchSize: 12,
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['followers', i18next.t('Followers')],
        ['contributions', i18next.t('Contributions')],
        ['pageviews', i18next.t('Views')],
      ],
      loadMoreQuery: InitiativeCommunityProfileProjectsQuery,
    });
    this.variables.onChange(['slug'], this.HandleNewSlug);
  }

  @action
  HandleNewSlug = () => {
    this.projectsConn.Reset();
    this.NewInitiativeProjectsQuery();
  };

  @action
  NewInitiativeProjectsQuery = () => {
    this.projectsConn.loadMore();
  };
}
